import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Form, Input } from 'antd';
import { register } from './RegisterFormApi';

const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  color: var(--primary-text);
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
`;

const InfoContent = styled.div`
  font-size: 18px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormInput = styled(Input)`
  width: 400px;
`;

function RegisterForm() {
  const [isEditMode, setIsEditMode] = useState(true);
  const [infoMessage, setInfoMessage] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);

  const onSubmit = (values) => {
    setIsRegistering(true);
    register(values)
      .then(({ data }) => {
        setIsEditMode(false);
        setInfoMessage(data.Message);
      })
      .catch(() => {
        setIsEditMode(false);
        setInfoMessage('Đang ký thất bại');
      })
      .finally(() => {
        setIsRegistering(false);
      });
  };

  const keepRegister = () => {
    setIsEditMode(true);
    setInfoMessage('');
  };

  return (
    <Wrapper>
      <Title>Đăng Ký Tài Khoản</Title>
      {isEditMode ? (
        <Form
          name="registerForm"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          style={{ maxWidth: 1000 }}
          initialValues={{ remember: true }}
          onFinish={onSubmit}
          autoComplete="off"
        >
          <Form.Item
            label="Số thẻ"
            name="CardNumber"
            rules={[{ required: true, message: 'Điền Số thẻ sinh viên' }]}
          >
            <FormInput />
          </Form.Item>
          <Form.Item
            label="Họ và Tên"
            name="Fullname"
            rules={[{ required: true, message: 'Điền Họ và Tên' }]}
          >
            <FormInput />
          </Form.Item>
          <Form.Item
            label="Số điện thoại"
            name="PhoneNumber"
            rules={[{ required: true, message: 'Điền số điện thoại' }]}
          >
            <FormInput />
          </Form.Item>
          <Form.Item
            label="Email"
            name="Email"
            rules={[{ required: true, message: 'Điền Email' }]}
          >
            <FormInput />
          </Form.Item>
          <Form.Item className="flex justify-end">
            <Button type="primary" htmlType="submit" loading={isRegistering}>
              Đăng Ký
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <InfoContent>
          <div>{infoMessage}</div>
          <Button onClick={keepRegister} type="primary">
            Tiếp tục đăng ký
          </Button>
        </InfoContent>
      )}
    </Wrapper>
  );
}

export default RegisterForm;
